/**
 * Hook for using local storage and value.
 * Get requested value from local storage.
 * If there is no value in storage, use inital value.
 */
export const useLocalStorage = (key: string, initialValue: any) => {
  let storedValue;
  try {
    const item = window?.localStorage?.getItem(key);
    storedValue = item ? JSON.parse(item) : initialValue;
  } catch (error) {
    storedValue = initialValue;
  }

  const setValue = (newValue: any) => {
    window?.localStorage?.setItem(key, JSON.stringify(newValue));
  };

  return [storedValue, setValue];
};
